import { FC, SVGProps } from 'react'

interface PublishIconProps extends SVGProps<SVGSVGElement> {
  size?: number
  color?: string
}

export const PublishIcon: FC<PublishIconProps> = ({
  size = 24,
  color = '#FFFFFF',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M437.682 927.944c-17.673 0-32-14.327-32-32v-235.2c0-17.673 14.327-32 32-32s32 14.327 32 32v235.2c0 17.673-14.327 32-32 32z"
        fill={color}
      />
      <path
        d="M444.929 685.966a31.878 31.878 0 0 1-20.752-7.654c-13.446-11.47-15.048-31.668-3.579-45.113l452.025-529.934c11.468-13.444 31.665-15.048 45.112-3.579 13.446 11.469 15.049 31.667 3.579 45.113L469.29 674.731c-6.329 7.42-15.318 11.235-24.361 11.235zM794.905 895.954a31.875 31.875 0 0 1-14.07-3.277L542.347 775.683c-15.866-7.784-22.419-26.956-14.636-42.823 7.783-15.866 26.957-22.419 42.823-14.636l238.488 116.994c15.866 7.784 22.419 26.956 14.636 42.823-5.558 11.331-16.929 17.913-28.753 17.913zM324.426 650.466a31.853 31.853 0 0 1-15.102-3.809L114.875 542.324c-15.573-8.355-21.424-27.754-13.068-43.327 8.356-15.574 27.755-21.424 43.327-13.068l194.449 104.333c15.573 8.355 21.424 27.754 13.068 43.327-5.772 10.759-16.816 16.877-28.225 16.877z"
        fill={color}
      />
      <path
        d="M130.332 544.135c-11.683 0-22.938-6.419-28.576-17.555-7.982-15.768-1.67-35.021 14.098-43.003L882.516 95.481c15.771-7.982 35.021-1.669 43.004 14.098 7.981 15.768 1.67 35.021-14.099 43.003L144.759 540.678a31.883 31.883 0 0 1-14.427 3.457z"
        fill={color}
      />
      <path
        d="M797.13 896.074c-1.42 0-2.855-0.095-4.302-0.289-17.517-2.354-29.807-18.461-27.453-35.978l99.084-737.288c2.354-17.516 18.458-29.806 35.977-27.453 17.517 2.354 29.807 18.461 27.453 35.977l-99.084 737.288c-2.159 16.07-15.897 27.743-31.675 27.743z"
        fill={color}
      />
    </svg>
  )
}
